import * as settings from '../actions/settings';
import { SettingsConstants } from '../settings/settings.constants';

export interface State {
  locations: any[];
  successMessage: string;
}

export const initialState: State = {
  locations: [],
  successMessage: ''
};

export function reducer(state = initialState, action: settings.Actions): State {
  switch (action.type) {
    case settings.ActionTypes.FAVORITE_LOCATIONS_UPDATED: {
      return {
        ...state,
        successMessage: SettingsConstants.settingsUpdateSuccess
      };
    }

    case settings.ActionTypes.SUCCESS_MESSAGE_DISMISSED: {
      return {
        ...state,
        successMessage: ''
      };
    }

    default: {
      return state;
    }
  }
}

export const getLocations = (state: State) => state.locations;

export const getSuccessMessage = (state: State) => state.successMessage;
